import {
  HumanReadableTextFormatterInterface,
  HumanReadableTextFormatterLang,
} from './human-readable-text-formatter.impl';
import { Money } from '../../../features/domain/value-objects/Money';

export interface HumanReadableCurrencyFormatterProps {
  amount: number;
  decimals?: number;
  lang?: keyof typeof HumanReadableTextFormatterLang;
}

class HumanReadableCurrencyFormatter extends HumanReadableTextFormatterInterface<
  HumanReadableCurrencyFormatterProps,
  { amount: number; symbol: string }
> {
  private static readonly CURRENCY_SYMBOL = {
    KR: '원',
    EN: '$',
    JP: '¥',
  };

  protected toKR() {
    const { amount } = this.props;
    return {
      amount: Money.of(amount).round().getAmount(),
      symbol: HumanReadableCurrencyFormatter.CURRENCY_SYMBOL.KR,
    };
  }

  protected toEN() {
    const { amount } = this.props;
    return {
      amount: Money.of(amount).toUSD().round().getAmount(),
      symbol: HumanReadableCurrencyFormatter.CURRENCY_SYMBOL.EN,
    };
  }

  protected toJP() {
    const { amount } = this.props;
    return {
      amount: Money.of(amount).toJPY().round().getAmount(),
      symbol: HumanReadableCurrencyFormatter.CURRENCY_SYMBOL.JP,
    };
  }
}

export const formatter = {
  humanize: (props: HumanReadableCurrencyFormatterProps) =>
    new HumanReadableCurrencyFormatter(props).humanize(),
};
